"use client";
import { useState, Suspense } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import './ResourceGrid.css';
import ResourceGridTab from "./ResourceGridTab";

// export interface blogCard {
//   eyebrow?: string;
//   header: string;
//   date: string;
//   image: {
//     url: string;
//     alt: string;
//     height: number;
//     width: number;
//     x: number;
//     y: number;
//     title: string;
//   };
//   destination?: string;
//   description: string;
//   button?: {
//     destination: string;
//     label: string;
//   };
//   tabLabel?: string; // Label that determines which tab the card belongs to
//   tags?: string[]; // Tags for filtering
// }

export interface ResourceGridProps {
  eyebrow?: string;
  header?: string;
  subheader?: string;
  description?: any;
  headerElement?: "h1" | "h2";
  tabsList: any;
  allResourceCards?: any[];
  config?: any;
  loadMoreText?: string;
  onLoadMore?: () => void;
  presetTheme?:
    | "t2-preset-theme-one"
    | "t2-preset-theme-two"
    | "t2-preset-theme-three"
    | "t2-preset-theme-four"
    | "t2-preset-theme-five"
    | "t2-preset-theme-six"
    | "t2-preset-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  draftEnabled?: boolean;
  lang?: string;
  cardDisplayMode?: "AND" | "OR";
}

export const TabbedResourceGrid = ({
  eyebrow,
  header,
  subheader,
  description,
  headerElement = "h2",
  tabsList,
  allResourceCards,
  config,
  isHeaderBig,
  isWrapped,
  presetTheme,
  draftEnabled,
  lang, 
  cardDisplayMode
}: ResourceGridProps) => {
  
  const [activeTab, setActiveTab] = useState(0);

  const mainClasses = `rc-resource-grid ${presetTheme || ""} t2-wrapper`;


  const formatTabFilters = (tab: any) => {
    const filterTags = tab?.filterByTagsCollection?.items?.map((tag: any, index: number) => {
      // const oldValues = tag?.linkedFrom?.blogTagCollection?.items?.map((tag: any) => {
      //   return {
      //     label: tag?.displayName,
      //     id: tag?.sys?.id
      //   }
      // });
      const newValues = tag?.tagSectionCollection?.items?.map((tag: any) => {
        return {
          label: tag?.displayName,
          id: tag?.sys?.id
        }
      });
      // console.log("newValues", newValues);

      return {
        id: tag?.sys?.id,
        title: tag?.displayName,
        dropdownValues: newValues
      };
    });
    return { filterTags };
  }

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div className={mainClasses}>
      {(eyebrow || header ) && <div className="rc-resource-grid__header-area t2-header-area">
        {eyebrow && (
          <div className="rc-resource-grid__eyebrow t2-layout__eyebrow">
            {eyebrow}
          </div>
        )}
        {header && (
          <h2 className="rc-resource-grid__header t2-layout__header">
            {header}
          </h2>
        )}
      </div>}

      <Tabs selectedIndex={activeTab} 
        onSelect={handleTabClick}
      >
        <TabList>
          {tabsList?.map((tab: any, index: number) => (
            <Tab key={index}>{tab?.displayName}</Tab>
          ))}
        </TabList>

        {/* Filtering Section */}
        {tabsList?.map((tab: any, index: any) => {
          const mainTabCardFilters = tab?.filterContentByTagsCollection?.items?.map((tag: any) => {
            return { title: tag?.displayName, id: tag?.sys?.id }
          })
          return (
            <TabPanel key={index} className="resource-grid__tab-panel">
              <Suspense fallback={<div>Loading...</div>}>
                <ResourceGridTab 
                  key={index} 
                  id={tab?.sys?.id}
                  index={index} 
                  displayName={tab?.displayName} 
                  filters={formatTabFilters(tab)}
                  activeTab={activeTab}
                  typeToGather={tab?.typeToGather}
                  cardDisplayMode={cardDisplayMode}
                  mainCardFilters={mainTabCardFilters} // filtering all cards in a tab by this main filter
                  config={config}
                  allCards={allResourceCards}
                  lang={lang}
                />
              </Suspense>
            </TabPanel>
          )   
        })}
      </Tabs>
    </div>
  );
};
